import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import { freezePayment, getLink } from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";
import ReactInputMask from "react-input-mask";

const CertificatePaymentModal = ({ visible, setVisible, clientInfo}) => {

  const dispatch = useDispatch();
 
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList
  );
  const clientAbonements = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientList
  );

  const [abonementClubId, setAbonementClubId] = useState(null);
  const [defPurch, setDefPurch] = useState(false);
  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState(dayjs());
  const [useStop, setUseStop] = useState();
  const [addStop, setAddStop] = useState();
  const [price, setPrice] = useState();
  const [selectedOpt, setSelectedOpt] = useState("Сертификат");
  const [modeAdd, setModeAdd] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [visibleLinkModal, setVisibleLinkModal] = useState(false);
  const [certificatePaymentUrl, setCertificatePaymentUrl] = useState(""); // Исправлено название

  const payOptions = [{ value: "Сертификат" }];
 
  const onClickAddLink = () => {
    const cleanPhone = phone.startsWith('+') ? phone.replace(/[^0-9+]/g, '') : '+' + phone.replace(/[^0-9]/g, '');
    
    dispatch(getLink({
        flag: "post",
        method: selectedOpt,
        value: {
            abonementClubsId: abonementClubId,
            price: price,
            userPhone: cleanPhone,
            email: email,
        }
    })).then((value) => {
        dispatch(getClientsList());
        setVisible(false);
        
        const paymentLink = value?.payload?.data?.value?.value?.paymentLink;
        setCertificatePaymentUrl(paymentLink);
        setVisibleLinkModal(true); // Открываем модалку с ссылкой сразу
    });
  };

  useEffect(() => {
    setAbonementClubId();
  }, []);
  
  return (
    <>
      {/* Основная модалка */}
      <CModal
        alignment="center"
        visible={visible}
        aria-labelledby="VerticallyCenteredExample"
        onClose={() => {
          setVisible(false);
        }}
        keyboard={true}
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredExample">
            {"Добавить ссылку"}
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Flex vertical gap={16} style={{ marginTop: "20px" }}>
            <>
              <div>
                <Typography.Title level={5}>Метод оплаты</Typography.Title>
                <Select
                  style={{ width: "100%" }}
                  options={payOptions}
                  onChange={(value) => {
                    setSelectedOpt(value);
                  }}
                  placeholder={"Выбрать"}
                  value={selectedOpt}
                />
              </div>
              
              <div>
                <Typography.Title level={5}>Номер телефона</Typography.Title>
                <ReactInputMask
                  mask='+7 (999) 999-99-99'
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className='form-control'
                  placeholder='+7 (___) ___-__-__'
                />
              </div>

              <div>
                <Typography.Title level={5}>Почта</Typography.Title>
                <Input 
                  defaultValue=""
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>

              {!modeAdd ? (
                <>
                  <div>
                    <Typography.Title level={5}>Абонементы</Typography.Title>
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="label"
                      options={abonementsList?.data?.value}
                      onChange={(value, opt) => {
                        setAbonementClubId(value);
                        setDefPurch(opt.deffered_purchase_allowed);
                        setPrice(opt.abonementPrice);
                        
                        let months = Number(opt.monthCount);
                        if (months > 0) {
                          setTo(dayjs(from).add(months, "month"));
                        } else {
                          setTo(dayjs(from).add(1, "hour"));
                        }
                      }}
                      placeholder={"Выбрать"}
                      value={abonementClubId}
                    />
                  </div>

                  <div>
                    <Typography.Title level={5}>Цена</Typography.Title>
                    <Input
                      defaultValue=""
                      type="number"
                      value={price}
                      onChange={(e) => {
                        setPrice(e.target.value);
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <Typography.Title level={5}>Абонементы</Typography.Title>
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="label"
                      options={clientFullAbonements}
                      onChange={(value) => {
                        setAbonementClubId(value);
                      }}
                      placeholder={"Выбрать"}
                      value={abonementClubId}
                    />
                  </div>
                </>
              )}
            </>
          </Flex>
        </CModalBody>
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible(false);
            }}
            style={{ color: "#fff" }}
            color="secondary"
          >
            Закрыть
          </CButton>
          <CButton onClick={onClickAddLink} style={{ color: "#fff" }}>
            Добавить
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Модалка с ссылкой */}
      <CModal
  alignment="center"
  visible={visibleLinkModal}
  onClose={() => {
    setVisibleLinkModal(false);
    setCertificatePaymentUrl("");
  }}
  size="lg"
>
  <CModalHeader>
    <CModalTitle>Ссылка на оплату сертификата</CModalTitle>
  </CModalHeader>
  <CModalBody>
    <div style={{ wordBreak: 'break-all' }}>
      <Typography.Text strong style={{ fontSize: '16px' }}>
        Ссылка для оплаты:
      </Typography.Text>
      <div style={{ 
        marginTop: '10px', 
        background: '#f5f5f5', 
        padding: '15px', 
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: '14px'
      }}>
        <a 
          href={certificatePaymentUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ fontSize: '14px' }}
        >
          {certificatePaymentUrl}
        </a>
      </div>
    </div>
  </CModalBody>
  <CModalFooter>
    <CButton 
      onClick={() => {
        navigator.clipboard.writeText(certificatePaymentUrl);
        openNotification({
          title: "Успешно",
          description: "Ссылка скопирована в буфер обмена",
          type: "success"
        });
      }}
      color="primary"
      style={{ color: "#fff" }}
    >
      Копировать ссылку
    </CButton>
    <CButton 
      onClick={() => window.open(certificatePaymentUrl, '_blank')} 
      color="primary"
      style={{ color: "#fff" }}
    >
      Открыть в браузере
    </CButton>
    <CButton 
      onClick={() => {
        setVisibleLinkModal(false);
        setCertificatePaymentUrl("");
      }} 
      color="secondary"
      style={{ color: "#fff" }}
    >
      Закрыть
    </CButton>
  </CModalFooter>
</CModal>
    </>
  );
};

export default CertificatePaymentModal;